// @ts-nocheck
import {useListView} from '../../core/ListViewProvider'
import {UsersListToolbar} from './ReportsListToolbar'
import {UsersListGrouping} from './ReportsListGrouping'
import {UsersListSearchComponent} from './ReportsListSearchComponent'

type SearchProps = {
  adSearch: String
  setAdSearch: Function
}

const UsersListHeader = ({
  adSearch,
  setAdSearch,
  setSDate,
  setEDate,
  sDate,
  eDate,
  page,
  setPage,
  category,
  setCategory,
  status,
  setStatus,
}: SearchProps) => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      {/* <UsersListSearchComponent adSearch={adSearch} setAdSearch={setAdSearch} /> */}
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? (
          <UsersListGrouping />
        ) : (
          <UsersListToolbar
            sDate={sDate}
            setSDate={setSDate}
            eDate={eDate}
            setEDate={setEDate}
            page={page}
            setPage={setPage}
            status={status}
            setCategory={setCategory}
            setStatus={setStatus}
            category={category}
          />
        )}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {UsersListHeader}
